import { RouteRecordRaw } from 'vue-router'
import { Layout } from '@/routers/constant'

const router: Array<RouteRecordRaw> = [
  {
    path: '/business/refund',
    component: Layout,
    redirect: '/business/refund/index',
    meta: {
      title: '退款管理',
      keepAlive: true,
      requiresAuth: true
    },
    children: [
      {
        path: 'index',
        name: 'BusinessRefundIndex',
        component: () => import('@/views/business/refund/index.vue'),
        meta: {
          keepAlive: true,
          requiresAuth: true,
          title: '退款管理'
        }
      }
    ]
  }
]

export default router
